module.exports = __webpack_public_path__ + "static/media/jijinjinglibeijing.196d3f2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/jijinjinglibeijing.png
// module id = 2173
// module chunks = 0